import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../../components/ui";

export default function WorkflowSettings() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Workflow</CardTitle>
        <CardDescription>Manage workflow templates and automation rules.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="text-sm text-muted-foreground">
          Workflow settings module in progress.
        </div>
      </CardContent>
    </Card>
  );
}